/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Text, Icon } from '@components/atoms'
import { ListItemButton } from '@mui/material'

import { grey } from '@mui/material/colors'

import { MenuType } from '@redux/index'

interface PropsType {
	subMenu: MenuType
	onNavigateClick: (menu: MenuType) => void
}

export const DrawerSubMenuItem = (props: PropsType) => {
	// variables
	const submenuTextColor = React.useMemo(
		() => (location.pathname === props.subMenu.to ? grey[800] : grey[400]),
		[location.pathname, props.subMenu.to],
	)

	return (
		<ListItemButton
			css={[style, { color: submenuTextColor }]}
			sx={{ pl: 4 }}
			onClick={() =>
				props.subMenu.to !== undefined ? props.onNavigateClick(props.subMenu) : {}
			}
		>
			<Icon name="circle-small" style={{ color: submenuTextColor }} />
			<Text i18n={props.subMenu.i18n}>{props.subMenu.name}</Text>
		</ListItemButton>
	)
}

const style = css({
	height: '2rem',
})
